export const images = {
  icon: {
    pencil: '/assets/images/svg/icon-1.svg',
    camera: '/assets/images/svg/icon-2.svg',
    edit: '/assets/images/svg/icon-3.svg',
    label: '/assets/images/svg/icon-4.svg',
    track: '/assets/images/svg/icon-5.svg',
    tag: '/assets/images/svg/icon-6.svg',
    reorder: '/assets/images/svg/icon-7.svg',
    rerouter: '/assets/images/svg/icon-8.svg',
    split: '/assets/images/svg/icon-9.svg',
    bag: '/assets/images/svg/bag.svg',
    box: '/assets/images/svg/box.svg',
    tote: '/assets/images/svg/tote.svg',
    sign: '/assets/images/svg/sign.svg',
    idcard: '/assets/images/svg/id-card.svg',
    message: '/assets/images/svg/message.svg',
  },
};

export const IMAGE_TYPES = ['image/png', 'image/jpeg', 'image/jpg', 'image/heic', 'image/heif'];
